import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs: React.FC = () => {
  return (
    <section className="section bg-cream">
      <div className="container-base">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <h2 className="section-title text-left">About Us</h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed mb-6 sm:mb-8">
              Welcome to Alljoy Donut Shop in Bluffton, South Carolina! We're Troy and Kristie Derda —
              parents, entrepreneurs, and adventurers who swapped the icy Midwest winters for a temperate life
              in the Lowcountry.
            </p>

            {/* Hours Card */}
            <div className="card p-4 sm:p-5 mb-6 sm:mb-8 inline-block">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-xl bg-orange-100 flex items-center justify-center">
                  <svg className="w-5 h-5 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h4 className="font-semibold text-gray-800">Opening Hours:</h4>
              </div>
              <p className="text-gray-600 pl-[52px]">Fri - Sun<br /><span className="font-semibold text-gray-800">7:00AM – 1:00PM</span></p>
            </div>

            <div className="block">
              <Link to="/about" className="btn-teal">
                Read More
              </Link>
            </div>
          </div>

          {/* Team Image */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              {/* Decorative background */}
              <div className="absolute -inset-4 bg-gradient-to-br from-orange-200/40 to-teal-200/40 rounded-card-lg blur-2xl" />
              <div className="img-frame relative aspect-[4/3] shadow-elevated">
                <img
                  src="/team.png"
                  alt="Alljoy Donut Team"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
